/* eslint-disable sort-imports */
/* eslint-disable new-cap */
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import { HTTP_STATUS_OK } from '../../../smartpak/httpstatus';
import LoadLevelingViewModel from './loadlevelingviewmodel';
import PakItemViewModel from './pakitemviewmodel';
import customerInfo from '../../../controls/customerinfo';
import { stringToDate } from '../../../utils/date';
import { roundedToFixed } from '../../../utils/number';

const otsTypes = {
    ATS: 1,
    ServiceOTS: 2,
    OTS: 4
},
    colicareStatus = {
        UNKNOWN: 1,
        PENDING: 2,
        APPROVED: 3,
        DENIED: 4,
        ENROLLED: 5,
        ALLOWEDTOREAPPLY: 6,
        DANGERLAPSEAPPROVED: 7,
        DANGERLAPSEENROLLED: 8,
        LAPSED: 11
    };


function PakViewModel(model, onUpdateCallback) {
    var mapping = {
        ScheduledShipDate: {
            create: function (options) {
                return stringToDate(options.data, null, true).toString('ddd M/d');
            }
        },
        EstimatedArrivalDate: {
            create: function (options) {
                return stringToDate(options.data, null, true).toString('ddd M/d');
            }
        },
        Cost: {
            create: function (options) {
                return roundedToFixed(options.data, 2);
            }
        },
        CustomerCareLoadLevelingMessage: {
            create: function (options) {
                return new LoadLevelingViewModel(options.data);
            }
        },
        SupplementViewModels: {
            create: function (options) {
                return new PakItemViewModel(options.data, model.AccountId);
            }
        }
    };

    ko.mapping.fromJS(model, mapping, this);

    this.thumbnail = this.IsPortionPak()
        ? '/images/portionpak-cart-thumb80x80.jpg'
        : this.IsCanineSmartPak()
            ? '/images/caninepak-cart-thumb80x80.jpg'
            : '/images/smartpak-cart-thumb-80x80.jpg';

    this.builderUrl = '/AutoShipManager/Supplements/' + this.AccountId();

    this.saveNewsterChoice = function (accountId, shouldGetNewster) {
        return $.post('/cart/SetAccountNewster', { accountId: accountId, addNewster: shouldGetNewster });
    };

    this.SmartPakShouldGetNewster.subscribe(
        function (shouldGetNewster) {
            this.saveNewsterChoice(this.AccountId(), shouldGetNewster);
        }.bind(this)
    );

    this.discountedUnitPrice = ko.computed(
        function () {
            return roundedToFixed(this.DiscountedPrice(), 2);
        }.bind(this)
    );

    this.isFree = ko.computed(
        function () {
            return this.DiscountedPrice() === 0;
        }.bind(this)
    );

    this.unitPrice = roundedToFixed(this.SupplementViewModels()
        .reduce(function (seed, item) {
            return seed + item.ConditionalItemFullCharge();
        }, 0), 2);

    this.hasDiscounts =
        this.SupplementViewModels().filter(function (supplement) {
            return supplement.hasDiscounts;
        }).length > 0;

    this.discountsApplied = formatDiscounts(combineDiscounts(this.SupplementViewModels()));
    this.discountsAppliedTooltip = this.discountsApplied.length
        ? '<strong>Your savings</strong>:<br />' + this.discountsApplied.join('<br />')
        : '';
    this.discountsAppliedTitle = this.discountsApplied.length
        ? 'Your savings: ' + this.discountsApplied.join(', ')
        : '';

    this.hasColicareEligibleItem = this.SupplementViewModels().some(function (supplement) {
        return supplement.SupplementIsColiCareEligible();
    });

    this.colicareStatusId = ko.observable(0);
    this.hasColicareMessage = ko.computed(
        function () {
            var statusId = this.colicareStatusId(),
                hasCorrectColicareReasons;

            if (statusId === 0) {
                this.getRecipientColicareStatusId();
            }

            hasCorrectColicareReasons =
                statusId === colicareStatus.UNKNOWN ||
                statusId === colicareStatus.ALLOWEDTOREAPPLY ||
                statusId === colicareStatus.LAPSED;

            return hasCorrectColicareReasons && this.hasColicareEligibleItem;
        }.bind(this)
    );

    this.isServiceOTS = ko.observable(this.OtsType() === otsTypes.ServiceOTS);
    this.hasCanineServiceOTS = ko.observable(this.isServiceOTS());
    this.isOneTimeDelivery = ko.observable(this.isServiceOTS() ? 'serviceOTS' : this.IsAutoShip() ? 'ATS' : 'OTS');

    this.isSaving = ko.observable(false);

    this.onUpdateCallback = onUpdateCallback;

    this.isOneTimeDelivery.subscribe(
        function (val) {
            this.IsAutoShip(val === 'ATS');
            this.isServiceOTS(false);
            this.saveAutoShipSelection();
        }.bind(this)
    );

    this.hasCanineServiceOTS.subscribe(
        function (val) {
            this.IsAutoShip(val === false);
            this.isServiceOTS(val === true);
            this.saveAutoShipSelection();
        }.bind(this)
    );

    this.isSpeUser = ko.observable();

    if (customerInfo) {
        customerInfo.getCustomerInfo().done(function (response) {
            if (response && response.status === HTTP_STATUS_OK) {
                this.isSpeUser(response.content.isSpeUser);
            }
        }.bind(this));
    }

    this.hasConfirmation = isConfirmationPage();
}

$.extend(PakViewModel.prototype, {
    saveAutoShipSelection: function () {
        var url =
            '/api/shipping/UpdateAutoshipForSmartPak?accountId=' +
            this.AccountId() +
            '&isAutoShip=' +
            this.IsAutoShip() +
            '&isServiceOTS=' +
            this.isServiceOTS();

        this.isSaving(true);

        $.get(
            url,
            function (data) {
                this.isSaving(false);

                if (data.Status === HTTP_STATUS_OK) {
                    if (this.onUpdateCallback) {
                        this.onUpdateCallback();
                    }
                }
            }.bind(this)
        );
    },
    getRecipientColicareStatusId: function () {
        $.get('/api/coliCareDetail/getColiCarePolicyInfoByRecipient/' + this.AccountId()).done(
            function (data) {
                if (data.Status === HTTP_STATUS_OK) {
                    var content = data.Content;

                    if (content) {
                        this.colicareStatusId(content.PolicyStatusId);
                    }
                }
            }.bind(this)
        );
    }
});


function formatDiscounts(discounts) {
    return Object.keys(discounts).map(function (key) {
        return key + ': $' + roundedToFixed(discounts[key], 2);
    });
}

function combineDiscounts(supplements) {
    return supplements.reduce(function (destination, supplement) {
        return mergeDiscounts(destination, supplement.Discounts);
    }, {});
}

function mergeDiscounts(destination, source) {
    Object.keys(source).forEach(function (key) {
        var value = +source[key]();
        if (destination[key]) {
            destination[key] = destination[key] + value;
        } else {
            destination[key] = value;
        }
    });

    return destination;
}

function isConfirmationPage() {
    const $model = document.getElementById('ConfirmationModel');
    return !!($model && $model.value);
}

export default PakViewModel;
